import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import Logo from './Logo';
import BackToTopButton from './BackToTopButton';
import './Footer.css';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <>
      <footer className="footer-compact">
        <div className="container">
          <div className="footer-content-compact">
            
            {/* 1. Logo */}
            <div className="footer-logo-compact">
              <Logo size="small" />
            </div>

            {/* 2. Essential Links */}
            <nav className="footer-nav">
              <Link to="/bhakti-samadhan">{t('nav.bhaktiSamadhan')}</Link>
              <Link to="/live-darshan">{t('nav.bhaktiDarshan')}</Link>
              <Link to="/bhakti-jaapa">{t('nav.bhaktiJaapa')}</Link>
              <Link to="/online-pooja">{t('nav.onlinePooja')}</Link>
              <Link to="/bhakti-store">{t('nav.bhaktiStore')}</Link>
              <Link to="/bhakti-bal-chitra-katha">{t('nav.bhaktiBalChitraKatha')}</Link>
              <Link to="/bhakti-yoga">{t('nav.bhaktiYoga')}</Link>
              <Link to="/contact">{t('footer.contact')}</Link>
              {/* --- ADDED TERMS LINK HERE --- */}
              <Link to="/terms">{t('footer.terms', {}, 'Terms & Privacy Policy')}</Link>
              <Link to="/vastu">{t('nav.vastu', {}, 'Vastu')}</Link>
            </nav>

            {/* 3. Social Media Icons */}
            <div className="social-links-compact">
              <a href="https://www.facebook.com/anandmaya.biz" aria-label="Facebook" target="_blank" rel="noopener noreferrer"><i className="fab fa-facebook-f"></i></a>
              <a href="https://www.instagram.com/anandmaya.biz/" aria-label="Instagram" target="_blank" rel="noopener noreferrer"><i className="fab fa-instagram"></i></a>
            </div>

          </div>
          
          {/* 4. Copyright line & Legal Entity Declaration */}
          <div className="footer-bottom-compact">
            <p>&copy; {new Date().getFullYear()} Anandmaya. Owned & Operated by <strong>MAHAV TECHNOLOGIES LLP</strong>. {t('footer.allRightsReserved', {}, 'All Rights Reserved.')}</p>
          </div>
        </div>
      </footer>
      <BackToTopButton />
    </>
  );
};

export default Footer;